import { useEffect, useState } from 'preact/hooks';

export type Route =
  | 'home'
  | 'agenda'
  | 'contents'
  | 'pomodoro'
  | 'goals'
  | 'score'
  | 'analytics'
  | 'settings'
  | 'login'
  | 'design';

const DEFAULT_ROUTE: Route = 'home';
const VALID_ROUTES: Route[] = [
  'home',
  'agenda',
  'contents',
  'pomodoro',
  'goals',
  'score',
  'analytics',
  'settings',
  'login',
  'design',
];

export function currentRoute(): Route {
  const hash = window.location.hash.replace(/^#\/?/, '');
  const base = hash.split('/')[0] || DEFAULT_ROUTE;
  return VALID_ROUTES.includes(base as Route) ? (base as Route) : DEFAULT_ROUTE;
}

export function routeParam(): string | undefined {
  const hash = window.location.hash.replace(/^#\/?/, '');
  const parts = hash.split('/');
  return parts[1] || undefined;
}

export function navigate(route: Route, param?: string): void {
  window.location.hash = `/${route}${param ? `/${param}` : ''}`;
}

export function useRoute(): { route: Route; param: string | undefined } {
  const [state, setState] = useState<{ route: Route; param: string | undefined }>({
    route: currentRoute(),
    param: routeParam(),
  });

  useEffect(() => {
    const handler = () => setState({ route: currentRoute(), param: routeParam() });
    window.addEventListener('hashchange', handler);
    return () => window.removeEventListener('hashchange', handler);
  }, []);

  return state;
}
